import { createTheme } from "@mui/material/styles";

export default createTheme({
  palette: {
    primary: {
      main: "#9c27b0",
    },
    secondary: {
      main: "#8a8a8a",
    },
    info: {
      main: "#00afef",
    },
    text: {
      main: "#ffffff",
    },
    warning: {
      main: "#fc0303",
    },
  },
});
